<template>
  <div class="service-listing surveys-page">
    <div class="container">
      <div class="row">
        <!--filter component-->
        <div
          class="col-xs-3 col-lg-3 responsive-cancel-padding cancel-left-padding tablet-full-width"
        >
          <div class="filter-component">
            <filterservice
              :apiResponse="info"
              :filter="filterData"
              @depArr="depArr = $event"
              @categoryArr="cateArr = $event"
              @sectorArr="sectorArr = $event"
              @subArr="subArr = $event"
              @healthArr="healthArr = $event"
              @funcArr="funcArr = $event"
              @ruleArr="ruleArr = $event"
              @tarckApplyFilter="tarckApplyFilter = true"
              @SortType="SortType = $event"
              @assignToMeAction="assignToMe = $event"
              :filterClicked="tarckApplyFilter"
              :PageType="PageType"
              :surveys="surveys"
              v-if="info"
              :sectorLab="SectorLabel"
              :categoryLab="CategoryLabel"
              :productLab="ProductsLabel"
              :functionsLab="FunctionsLabel"
              :searchLab="SearchLabel"
              :CategoriesOfRules="CategoriesOfRules"
              @datestart="datestart = $event"
              @dateend="dateend = $event"
              @resetDate="resetDate = $event"
              :ClearDateFilter="ClearDateFilter"
              :FilterByDate="FilterByDate"
              :Apply="Apply"
              :Reset="Reset"
              :From="From"
              :key="reinitFilter"
              :To="To"
              :BackBtn="BackBtn"
              :Required="Required"
              :SortByDate="SortByDate"
              :FilterType="FilterType"
              :Ascending="Ascending"
              :Descending="Descending"
              :SurveyAssignToMe="SurveyAssignToMe"
              :SurveyMoreFilter="SurveyMoreFilter"
            />
            <div class="generic-loader filter-loader" v-if="apiCallLoader">
              <img src="../../../Assets/Images/spinner.svg" alt="EDA Spinner" />
            </div>
          </div>
        </div>

        <div
          class="col-xs-9 col-lg-9 responsive-cancel-padding tablet-full-width"
        >
          <div class="accordion-wrapper">
            <!--loader-->
            <div class="generic-loader" v-show="isAjaxLoading">
              <img src="../../../Assets/Images/spinner.svg" alt="EDA Spinner" />
            </div>

            <!--surveys component-->
            <div
              class="accordion"
              id="accordionExample"
              aria-multiselectable="true"
              v-if="surveys"
            >
              <h3 v-if="surveysNoData" class="empty-msg">
                {{ NoResultMessage }}
              </h3>
              <div v-if="filteredData.surveys.length != 0">
                <Survey-block
                  :surveyCardObj="surveyObj"
                  :serviceCardArr="filteredData.surveys"
                  :mobileView="mobileView"
                ></Survey-block>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import filterservice from "../GenericPageComponent/Filter/FilterService.vue";
import SurveyBlock from "../GenericListingComponent/SurveyBlock/SurveyCard.vue";


let baseUrl = document.location.origin;
let apiUrl = baseUrl + "";
let language = window.CurrentLanguage.CurrentLanguage;

export default {
  props: [
    "SectorLabel",
    "CategoryLabel",
    "ProductsLabel",
    "FunctionsLabel",
    "SearchLabel",
    "SearchPlaceHolder",
    "PageType",
    "tabs",
    "ClearDateFilter",
    "FilterByDate",
    "From",
    "To",
    "Required",
    "NoResultMessage",
    "CategoriesOfRules",
    "Download",
    "Apply",
    "Reset",
    "ServiceCost",
    "CentralAdministration",
    "PublicAdministration",
    "Specialization",
    "Cosmetic",
    "SecondaryCategory",
    "Category",
    "BackBtn",
    "SortByDate",
    "FilterType",
    "Ascending",
    "Descending",
    "SurveyStatus",
    "SurveyStartDate",
    "SurveyFunction",
    "SurveySector",
    "SurveyResponse",
    "SurveyEndDate",
    "SurveyHealthProduct",
    "SurveyDescription",
    "SurveyAssignToMe",
    "SurveyMoreFilter",
  ],
  components: {
    filterservice,
    SurveyBlock,
  },
  data() {
    return {
      pageNumber: 1,
      slideClicked: false,
      searchClicked: false,
      returnedNameFilter: null,
      info: null,
      userIds: [],
      data: [],
      cateArr: [],
      ruleArr: [],
      sectorArr: [],
      subArr: [],
      healthArr: [],
      funcArr: [],
      depArr: [],
      SortType: "",
      assignToMe: false,
      tarckApplyFilter: false,
      isAjaxLoading: true,
      filteredData: {
        surveys: [],
      },
      limit: 10,
      surveys: true,
      mobileView: false,
      reinitFilter: 0,
      filter: [],
      surveyObj: {},
      surveysNoData: false,
      apiCallLoader: false,
    };
  },
  methods: {
    async getInfo() {
      await axios.post(
          `${apiUrl}/Umbraco/Surface/Generic/GetAllFilters?pageType=${this.PageType}&culture=${language}`
        ).then((response) => {
          this.info = response.data;

          for (let item of this.info.Sectors) {
            this.$set(item, "checked", false);
            item.Department = item.Department.map((str, index) => ({
              value: str,
              id: index + 1,
              checked: false,
            }));
          }

          for (let item of this.info.HealthProducts) {
            this.$set(item, "checked", false);
          }

          for (let item of this.info.Functions) {
            this.$set(item, "checked", false);
          }
        }).catch(()=> {

        });
    },
    filterData() {
      this.isAjaxLoading = true;
      //debugger
      this.surveysNoData = false;

      this.data = [];

      if (this.tarckApplyFilter) {
        this.pageNumber = 1;
        this.filteredData.surveys = [];
        if (window.innerWidth > 1025) {
          this.apiCallLoader = true;
        }
      }

      let axiosData = {
        PageType: this.PageType,
        SortType: this.SortType,
        AssignedToMe: this.assignToMe,
        PageNumber: this.pageNumber,
        DateFrom: this.datestart,
        DateTo: this.dateend,
        HealthProducts: this.healthArr,
        Functions: this.funcArr,
        Sectors: this.sectorArr,
      };

      axios
        .post(`${apiUrl}/Umbraco/Surface/Generic/ApplyFilters?culture=${language}`, axiosData)
        .then((response) => {
          this.apiCallLoader = false;
          this.isAjaxLoading = false;

          this.tarckApplyFilter = false;

          this.data = response.data;

          //check if surveys

          if (this.data.length != 0) {
            this.slice();
          } else {
            if (this.filteredData.surveys.length != 0) {
              this.surveysNoData = false;
            } else {
              this.surveysNoData = true;
            }
          }
        })
        .catch(() => {});
    },
    slice() {
      this.filteredData.surveys = this.filteredData.surveys.concat(this.data);
    },
    checkTrigger() {
      setTimeout(() => {
        const options = {
          threshold: 0.1,
        };
        const checker = document.querySelector(".footer");
        const infiniteScroll = (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              if (this.data.length != 0) {
                this.isAjaxLoading = true;
                if (window.innerWidth > 1025) {
                  this.apiCallLoader = true;
                }
                setTimeout(() => {
                  this.pageNumber += 1;
                  this.filterData();
                  this.isAjaxLoading = false;
                }, 500);
              }
            }
          });
        };

        const observer = new IntersectionObserver(infiniteScroll, options);
        observer.observe(checker);
      }, 1000);
    },
  },
  beforeMount() {
    this.getInfo();
  },
  mounted() {
    document.querySelector(".register-page-form__loader").style.display = "none";
    if (window.innerWidth < 768) {
      this.mobileView = true;
    }

    this.surveyObj = {
      SurveyStatus: this.SurveyStatus,
      SurveyStartDate: this.SurveyStartDate,
      SurveyFunction: this.SurveyFunction,
      SurveySector: this.SurveySector,
      SurveyResponse: this.SurveyResponse,
      SurveyEndDate: this.SurveyEndDate,
      SurveyHealthProduct: this.SurveyHealthProduct,
      SurveyDescription: this.SurveyDescription,
    };
    this.filterData();
    this.checkTrigger();
  },
};
</script>
